import { Children, isValidElement } from 'react';
import { Mermaid } from '@/components/mermaid';

type PreFormatMatcher = {
  match: (el: React.ReactElement) => boolean;
  render: (props: React.ComponentProps<'pre'>) => React.ReactNode;
};

const classSyntaxMatcher = (lang: string) => (el: React.ReactElement) => {
  console.log(el.props);
  return el.props.className === `language-${lang}`;
};

const matchers: Record<string, PreFormatMatcher> = {
  mermaid: {
    match: classSyntaxMatcher('mermaid'),
    render: (props) => {
      const child = Children.only(props.children);
      const def = isValidElement(child) && child.props.children;
      return <Mermaid def={def} />;
    },
  },
};
export const MarkdownPre = (props: React.ComponentProps<'pre'>) => {
  // lookup a child element of type <code>
  const codeEl = Children.toArray(props.children).find((v) => {
    // eslint-disable-next-line
    return isValidElement(v) && (v.type as any).name === 'code';
  });

  if (codeEl) {
    // check if there is a syntax matcher for this element
    const matcher = Object.entries(matchers).find(([_, matcher]) =>
      matcher.match(codeEl as React.ReactElement)
    );

    if (matcher) {
      // use the syntax matcher to render the component instead of the default
      const [syntax, { render }] = matcher;
      console.log('Matched code block syntax: ', syntax);
      return render(props);
    }
  }

  // return the default browser <pre> component
  return <pre {...props} />;
};
